"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when a request returns BadRequestError because the class has reached the maximum size
 * @param {string} classId the class the user attempted to join
 */
class ClassSizeLimitExceeded extends client_library_1.ExtendableError {
    constructor(classId) {
        super(`class: ${classId} has reached the maximum number of enrolees`);
    }
}
exports.default = ClassSizeLimitExceeded;
//# sourceMappingURL=ClassSizeLimitExceeded.js.map